import config from 'config';

export default function createApiUrl() {
  return process.env.NODE_ENV === 'development'
    ? `${window.location.protocol}//${window.location.hostname}:${
        config.apiPort
      }/api/v${config.apiVersion}`
    : `${window.location.origin}/api/v${config.apiVersion}`;
}



// WEBPACK FOOTER //
// ./src/sources/apiUrlCreator.js